<!-- Boolean Input (Checkbox) for Inspector -->
<script lang="ts">
  import Checkbox from '@/ui/base/Checkbox.svelte';

  let {
    value = $bindable(false),
    label,
    onChange,
  }: {
    value: boolean;
    label?: string;
    onChange?: (value: boolean) => void;
  } = $props();

  function handleChange(checked: boolean) {
    value = checked;
    onChange?.(value);
  }
</script>

<div class="flex items-center gap-2">
  <Checkbox checked={value} onChange={handleChange} />
  {#if label}
    <span class="text-xs text-gray-300">{label}</span>
  {/if}
</div>
